module.exports = __webpack_public_path__ + "img/top2.601a478c.svg";